import type { FaireProductEntity } from "../../entity_types/product";

export const p_9k95raayfg: FaireProductEntity = {
  token: "p_9k95raayfg",
  type: "product",
  name: "Case-Mate Ballet Pink Large Jelly Cooler Tote 12L",
  brandToken: "b_7dpvor9hnj",
  brandName: "Case-Mate",
  imageUrl:
    "https://cdn.faire.com/fastly/e4b17679bbd65ba1da65fc49ee6e3a294683e41f5863945d8788d47af2776d71.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e098f3f9f82b7c1ef3edc2b1279d13a2134ab0e6975439ba87182ca56582706a.jpeg",
    "https://cdn.faire.com/fastly/9312f11266af3c1381659a2e76c1a0de24939a4c331ba6b3b08d2bef591f74c8.jpeg",
    "https://cdn.faire.com/fastly/18b27ea4cea6d9d013fbccc530128a917eeaebeb8d3efe0289d968fbaba7c572.jpeg",
    "https://cdn.faire.com/fastly/8120b79f5f650eac410acbbf33d41b70e51c5ed4e8bd9a0db4aee9490d1a7083.jpeg",
    "https://cdn.faire.com/fastly/1c491d1d05e94fa93be163fe2dea9aa3e4bddc5d545648a30903fa41bf22300f.jpeg",
    "https://cdn.faire.com/fastly/ac388018568418d5a790303b8fcdc67925fb468170cd91378d582ad262e75744.jpeg",
  ],
  priceDollars: 100,
  description:
    "Your next beach day just got cooler! The Jelly Cooler Tote is a must-have for poolside lounging, lake day getaways, and beach trips. Its zippered insulation keeps food, up to two dozen cans of your favorite beverage, or six wine bottles refreshingly cold for over 24 hours (yes, that’s ALL day!). Its lightweight, tote design makes it easy to carry and won’t weigh you down like bulky, plastic coolers. Featuring soft handles and a removable, adjustable shoulder strap, you can comfortably carry your cooler anywhere. The flat slip-resistant base keeps it steady wherever you set it down, while the zip-close ensures everything stays secure. After a day in the sun and sand, the waterproof material easily rinses off to keep it looking good as new and ready for your next trip.",
  tags: [],
  msrpDollars: 200,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:52.346Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
